import React from 'react';
import { Text } from '@atlaskit/primitives';
import { CART_COLUMNS_CONSTANTS } from '../../constants/cart-table';

export const getHeaders = ({
  isUOFFlow = true,
  currency,
  showAppificationChange,
  selectComponent,
}: {
  isUOFFlow: boolean;
  currency: string;
  selectComponent?: React.ReactNode;
  showAppificationChange: boolean;
}) => {
  if (isUOFFlow) {
    return [
      {
        id: 'select-all',
        name: CART_COLUMNS_CONSTANTS.SELECT,
        renderComponent: <th>{selectComponent}</th>,
      },
      {
        id: 'product-name',
        name: showAppificationChange ? CART_COLUMNS_CONSTANTS.SUBSCRIPTION : CART_COLUMNS_CONSTANTS.PRODUCT,
        customClassNames: 'col-product-name',
      },
      {
        id: 'product-plan',
        name: CART_COLUMNS_CONSTANTS.PLAN,
        customClassNames: 'col-common-header',
      },
      {
        id: 'product-quantity',
        name: CART_COLUMNS_CONSTANTS.QUANTITY,
        customClassNames: 'col-common-header',
      },
      {
        id: 'product-next-bill-date',
        name: CART_COLUMNS_CONSTANTS.NEXT_BILL_DATE,
        customClassNames: 'col-common-header',
      },
      {
        id: 'product-list-price',
        name: CART_COLUMNS_CONSTANTS.LIST_PRICE,
        renderComponent: (
          <th className="col-common-header">
            <Text>
              {CART_COLUMNS_CONSTANTS.LIST_PRICE}
              {currency && ` (${currency})`}
            </Text>
          </th>
        ),
      },
      {
        id: 'product-other-discount',
        name: CART_COLUMNS_CONSTANTS.OTHER_DISCOUNT,
        renderComponent: (
          <th className="col-common-header">
            <Text>
              {CART_COLUMNS_CONSTANTS.OTHER_DISCOUNT}
              {currency && ` (${currency})`}
            </Text>
          </th>
        ),
      },
      {
        id: 'product-partner-discount',
        name: CART_COLUMNS_CONSTANTS.PARTNER_DISCOUNT,
        renderComponent: (
          <th className="col-common-header">
            <Text>
              {CART_COLUMNS_CONSTANTS.PARTNER_DISCOUNT}
              {currency && ` (${currency})`}
            </Text>
          </th>
        ),
      },
      {
        id: 'product-tax-estimate',
        name: CART_COLUMNS_CONSTANTS.TAX_ESTIMATE,
        renderComponent: (
          <th className="col-common-header">
            <Text>
              {CART_COLUMNS_CONSTANTS.TAX_ESTIMATE}
              {currency && ` (${currency})`}
            </Text>
          </th>
        ),
      },
      {
        id: 'product-total',
        name: CART_COLUMNS_CONSTANTS.TOTAL,
        renderComponent: (
          <th className="col-common-header">
            <Text>
              {CART_COLUMNS_CONSTANTS.TOTAL}
              {currency && ` (${currency})`}
            </Text>
          </th>
        ),
      },
      {
        id: 'product-status',
        name: CART_COLUMNS_CONSTANTS.STATUS,
        renderComponent: (
          <th className="col-common-header">
            <Text>{CART_COLUMNS_CONSTANTS.STATUS} </Text>
          </th>
        ),
      },
      {
        id: 'product-add-new',
        name: 'Add',
        customClassNames: 'col-product-add-new',
      },
    ];
  }
  // TODO: Update for quote flow
  return [
    {
      id: 'select-all',
      name: CART_COLUMNS_CONSTANTS.SELECT,
      renderComponent: <th>{selectComponent}</th>,
    },
    {
      id: 'product-name',
      name: showAppificationChange ? CART_COLUMNS_CONSTANTS.SUBSCRIPTION : CART_COLUMNS_CONSTANTS.PRODUCT,
      customClassNames: 'col-product-name',
    },
    {
      id: 'product-plan',
      name: CART_COLUMNS_CONSTANTS.PLAN,
      customClassNames: 'col-common-header',
    },
    {
      id: 'product-quantity',
      name: CART_COLUMNS_CONSTANTS.QUANTITY,
      customClassNames: 'col-common-header',
    },
    {
      id: 'product-next-bill-date',
      name: CART_COLUMNS_CONSTANTS.NEXT_BILL_DATE,
      customClassNames: 'col-common-header',
    },
    {
      id: 'product-list-price',
      name: CART_COLUMNS_CONSTANTS.LIST_PRICE,
      renderComponent: (
        <th className="col-common-header">
          <Text>
            {CART_COLUMNS_CONSTANTS.LIST_PRICE}
            {currency && ` (${currency})`}
          </Text>
        </th>
      ),
    },
    {
      id: 'product-other-discount',
      name: CART_COLUMNS_CONSTANTS.OTHER_DISCOUNT,
      renderComponent: (
        <th className="col-common-header">
          <Text>
            {CART_COLUMNS_CONSTANTS.OTHER_DISCOUNT}
            {currency && ` (${currency})`}
          </Text>
        </th>
      ),
    },
    {
      id: 'product-partner-discount',
      name: CART_COLUMNS_CONSTANTS.PARTNER_DISCOUNT,
      renderComponent: (
        <th className="col-common-header">
          <Text>
            {CART_COLUMNS_CONSTANTS.PARTNER_DISCOUNT}
            {currency && ` (${currency})`}
          </Text>
        </th>
      ),
    },
    {
      id: 'product-tax-estimate',
      name: CART_COLUMNS_CONSTANTS.TAX_ESTIMATE,
      renderComponent: (
        <th className="col-common-header">
          <Text>
            {CART_COLUMNS_CONSTANTS.TAX_ESTIMATE}
            {currency && ` (${currency})`}
          </Text>
        </th>
      ),
    },
    {
      id: 'product-total',
      name: CART_COLUMNS_CONSTANTS.TOTAL,
      renderComponent: (
        <th className="col-common-header">
          <Text>
            {CART_COLUMNS_CONSTANTS.TOTAL}
            {currency && ` (${currency})`}
          </Text>
        </th>
      ),
    },
    {
      id: 'product-status',
      name: CART_COLUMNS_CONSTANTS.STATUS,
      renderComponent: (
        <th className="col-common-header">
          <Text>{CART_COLUMNS_CONSTANTS.STATUS} </Text>
        </th>
      ),
    },
    {
      id: 'product-add-new',
      name: 'Add',
      customClassNames: 'col-product-add-new',
    },
  ];
};
